module.exports = __webpack_public_path__ + "static/img/zhinengzixun.dda07040.png";